import {
  createSupplier,
  deleteSupplier,
  getSuppliers,
  getType,
  updateSupplier,
} from '../actions/suppliers';
import { INIT_STATE } from './state';

export default function suppliersReducers(
  state = INIT_STATE.suppliers,
  action
) {
  const { type, payload } = action;

  switch (type) {
    case getType(getSuppliers.getSuppliersRequest()):
      return {
        ...state,
        loading: true,
      };

    case getType(getSuppliers.getSuppliersSuccess()):
      return {
        ...state,
        loading: false,
        data: payload,
      };

    case getType(getSuppliers.getSuppliersFailure()):
      return {
        ...state,
        loading: false,
      };

    case getType(createSupplier.createSupplierSuccess()):
      return {
        ...state,
        loading: false,
        data: [...state.data, payload],
      };

    case getType(createSupplier.createSupplierFailure()):
      return {
        ...state,
        loading: false,
      };

    case getType(updateSupplier.updateSupplierSuccess()):
      return {
        ...state,
        loading: false,
        data: state.data.map((supplier) =>
          supplier.id === payload.id ? payload : supplier
        ),
      };

    case getType(updateSupplier.updateSupplierFailure()):
      return {
        ...state,
        loading: false,
      };

    case getType(deleteSupplier.deleteSupplierSuccess()):
      return {
        ...state,
        loading: false,
        data: state.data.filter((supplier) => supplier.id !== payload.id),
      };

    case getType(deleteSupplier.deleteSupplierFailure()):
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}
